module.exports = __webpack_public_path__ + "static/andrew-webster-4c5351f47a694bcdd82a1b6c19bf070c.webp";